import IdentificationNumber from './identification-number'

export default IdentificationNumber
